import { handleResponse } from '../../Helpers/handle-response';
import * as apiHelper from '../../Helpers/apiHelper';

export function getSystemParametersByIdList(systemParameterIds) {
    const requestOptions = {
        method: 'GET', headers: {
            'Content-Type': 'application/json',
        }
    };

    let idString = ""
    for (var id of systemParameterIds) {
        idString += String(id) + ","
    }
    idString = idString.substring(0, idString.length - 1);
    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSYTEMPARAMETERSBYIDLIST);
    url += `?ids=${idString}`;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}